import { ChargingInfoType, RawChargingInfo } from './types';

export const parseChargingInfo = (
  charging: RawChargingInfo,
  fuelType: string
): ChargingInfoType => {
  return {
    isEV: fuelType.toLowerCase() === 'electric',
    level1: charging.ChargingTime120V,
    level2: charging.ChargingTime240V,
    level3: charging.ChargingTimeDC,
    peakChargeRate: charging.ChargingPeakRateDC,
    chargingConnectorDC: charging.ChargingConnectorDC,
  };
};
